<template>
  <div id="exhibitions">

    <sub-menu id="section-submenu" nohide="true"></sub-menu>

    <h3 v-if="currentExhibitions" class="mt3 center caps pb1">Current & Upcoming</h3>

    <current v-if="currentExhibitions" :content="currentExhibitions"></current>

    <section v-if="featuredExhibitions.length">
      <h3 class="mt3 mb0 center caps">Featured Exhibitions</h3>
      <exhibition-blocks
        v-if="exhibitions"
        id="featured-exhibitions"
        type="featured"
        class="lazy-container"
        @updated="updateLazy()"
        :items="featuredExhibitions"></exhibition-blocks>
    </section>


    <section v-if="exhibitions && otherExhibitions.length">
      <h3 class="mb3 center caps">Other Exhibitions</h3>
      <div class="mx2 sm-mx3">
        <router-link
          v-for="exhibition in otherExhibitions"
          class="row clearfix border-top py1 block other-exhibition-row"
          :to="{ name: 'Exhibition', params: { slug: exhibition.slug }}"
          :key="exhibition.id">
            <div class="col col-3 tabular xs-hide">
              {{ exhibitionDates(exhibition) }}
            </div>
            <div class="col col-12 sm-col-9 mxn2">
              <div class="row clearfix">
                <div class="col col-8 px2 caps hover-red">
                  {{ exhibition.title }}
                  <div class="sm-hide md-hide lg-hide mt1">{{ exhibitionDates(exhibition) }}</div>
                </div>
                <div class="col col-4 px2">
                  {{ exhibition.venue }}
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </section>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState, mapGetters } from 'vuex'
import { getPreviewVideoFile, getPreviewImageFile, getPreviewImageStyle, exhibitionDates } from '@/utils'
import SubMenu from '@/components/SubMenu'
import ExhibitionBlocks from '@/components/ExhibitionBlocks'
import CardBlock from '@/components/CardBlock'
import Current from '@/components/Current'

export default {

  name: 'Exhibitions',

  data () {
    return {
      lazyContainer: this.lazyLoad({
        elements_selector: ".lazy-container img"
      })
    }
  },

  metaInfo () {
    let title = `Exhibitions`

    return {
      title: title,
      meta: [
        { name: 'og:title', content: title },
        { name: 'twitter:title', content: title },
        { name: 'og:image', content: '/fa-share-lg.png' },
        { name: 'twitter:image', content: '/fa-share-lg.png' },
        { name: 'og:url', content: `${window.location.origin}/${this.$route.fullPath}` },
        { name: 'og:type', content: 'website' },
        { name: 'og:description', content: this.siteDescription() },
      ]
    }
  },

  components: {
    ExhibitionBlocks,
    CardBlock,
    Current,
    SubMenu
  },

  mounted () {
    this.$nextTick(function () {
      this.lazyContainer.update()
      this.equalizeHeights()
    })
    window.onresize = debounce(() => {
      this.equalizeHeights()
    }, 100)
  },

  computed: {
    ...mapState([
      'exhibitions'
    ]),
    ...mapGetters([
      'currentExhibitions',
      'featuredExhibitions',
      'otherExhibitions'
    ])
  },

  methods: {
    debounce,
    getPreviewVideoFile,
    getPreviewImageFile,
    getPreviewImageStyle,
    exhibitionDates,
    currentExhibition (exhibition) {
      if (exhibition.acf.start) {
        return (this.datePosition(exhibition.acf.start.date) || this.datePosition(exhibition.acf.end.date))
      } else {
        return false
      }
    },
    exhibitionCategory (item) {
      if (item.type) {
        return item.type[0].name
      } else {
        return ''
      }
    },
    // TODO: Redundant from Investigations.vue?
    equalizeHeights () {
      console.log('equalizing')
      let items = Array.prototype.slice.call(document.querySelectorAll('.exhibition')).reduce(function(result, value, index, array) {
        if (index % 2 === 0)
          result.push(array.slice(index, index + 2))
        return result
      }, [])

      let classes = ['.exhibition-title', '.card-row']

      items.map(x => {
        if (x.length === 2) {

          classes.map(className => {
            let a = x[0].querySelector(className)
            let b = x[1].querySelector(className)
            a.removeAttribute('style')
            b.removeAttribute('style')
            let maxHeight = Math.max.apply(Math, [a.clientHeight, b.clientHeight])
            a.style.height = maxHeight + 'px'
            b.style.height = maxHeight + 'px'
          })
        }
      })
    },
    updateLazy () {
      this.$nextTick(function () {
        console.log('updated')
        this.lazyContainer.update()
      })
    }
  }
}
</script>

<style lang="css" scoped>
  #exhibitions-current {
    position: fixed;
    bottom: -55vh;
    left: 0;
    right: 0;
    height: 60vh;
    transition: all 0.2s ease-out;
    overflow-y: scroll;

    &:hover {
      bottom: 0;
    }
  }

  .other-exhibition-row {
    min-height: 3em;

    &:hover {
      .hover-red {
        color: var(--red);
      }
    }
  }
</style>
